import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHighlights: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHighlights"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M11.5 10H3" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 14H3" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 18H5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 6H5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHighlights;
